import React from "react";

import { Props } from "@/mk2/apps/strollers/containers/StrollerAllReviewsPhotosGallery/StrollerAllReviewsPhotosGalleryPage";
import { strollersAllReviewsPhotosUrl } from "@/mk2/apps/strollers/urls";
import { ImgCropMode, ImgCropped } from "@/mk2/components/ImgCropped";
import { Link } from "@/mk2/components/Link";
import { LoadingSwitch } from "@/mk2/containers/LoadingSwitch/LoadingSwitch";
import { url } from "@/mk2/helpers/urls";
import { photoUrl } from "@/mk/photo/photoUrl";

import styles from "./StrollerAllReviewsPhotosGallery.mscss";

interface State {
    imagesDivWidth: number;
}

export class StrollerAllReviewsPhotosGallery extends React.Component<Props, State> {
    private imagesDivRef: React.RefObject<HTMLDivElement> = React.createRef();

    constructor(props: Props) {
        super(props);
        this.state = {
            imagesDivWidth: null,
        };
    }

    public componentDidMount() {
        if (this.imagesDivRef.current) {
            this.setState({ imagesDivWidth: this.imagesDivRef.current.clientWidth });
        }
    }

    public componentDidUpdate(
        prevProps: Readonly<Props>,
        prevState: Readonly<State>,
        snapshot?: any,
    ) {
        if (this.imagesDivRef.current && !this.state.imagesDivWidth) {
            this.setState({ imagesDivWidth: this.imagesDivRef.current.clientWidth });
        }
    }

    public render() {
        const { loadingState, stroller } = this.props;

        return (
            <div className={styles.StrollerAllReviewsPhotosGallery} ref={this.imagesDivRef}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderSuccess={this.renderSuccess}
                    hasData={!!stroller}
                />
            </div>
        );
    }

    private renderSuccess = () => {
        const { strollerReviewsPhotos, stroller } = this.props;
        const imagesDivWidth = this.imagesDivRef?.current?.clientWidth || 600;
        const imageSize = Math.floor((imagesDivWidth - 10) / 4) - 2;
        return (
            <div className={styles.StrollerAllReviewsPhotosGallery__images}>
                {strollerReviewsPhotos.map((image, idx) => {
                    return (
                        <Link
                            to={url(strollersAllReviewsPhotosUrl, {
                                slug: stroller.slug,
                                reviewId: image.review.id,
                                photoId: image.photoFile.id,
                            })}
                            key={`photo-${idx}`}
                        >
                            <div className={styles.StrollerAllReviewsPhotosGallery__image}>
                                <ImgCropped
                                    mode={ImgCropMode.Cover}
                                    imgUrl={photoUrl(image.photoFile, "s720x720")}
                                    imgWidth={image.photoFile.width}
                                    imgHeight={image.photoFile.height}
                                    width={imageSize}
                                    height={imageSize}
                                />
                            </div>
                        </Link>
                    );
                })}
            </div>
        );
    };

    private load = () => {
        const { strollerSlug, onLoad } = this.props;
        onLoad(strollerSlug);
    };
}
